/**
 * Lightweight pageview tracker.
 *
 * Fires a single POST to /api/analytics/pageview on every route change.
 * Persists a random session_id in sessionStorage so a single visit groups
 * its pageviews. Captures referrer, UTM tags, page title, viewport.
 *
 * Designed to be completely silent — failures are swallowed.
 */
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = "nodera_analytics_session";

function getSessionId() {
  try {
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = Math.random().toString(36).slice(2, 14) + Date.now().toString(36);
      sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    return null;
  }
}

function readUtm(search) {
  const p = new URLSearchParams(search || "");
  return {
    utm_source: p.get("utm_source") || null,
    utm_medium: p.get("utm_medium") || null,
    utm_campaign: p.get("utm_campaign") || null,
  };
}

export function trackPageview(pathname, search) {
  try {
    const path = pathname || window.location.pathname;
    // Hard skip — never instrument admin / portal / vendor panels.
    if (path.startsWith("/admin") || path.startsWith("/portal") || path.startsWith("/vendor")) {
      return;
    }
    const body = {
      path,
      referrer: document.referrer || null,
      session_id: getSessionId(),
      page_title: document.title || null,
      screen_width: window.innerWidth || null,
      screen_height: window.innerHeight || null,
      ...readUtm(search || window.location.search),
    };
    fetch(`${BACKEND}/api/analytics/pageview`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Silent.
  }
}

export function trackEvent(name, props) {
  try {
    fetch(`${BACKEND}/api/analytics/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name,
        props: props || {},
        session_id: getSessionId(),
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Silent.
  }
}
